import axios from "axios";
import {apiUrl} from "../../api/common";
import {Login} from "../../types/user/user";
import CartEvents from "../../events/CartEvents";
import LaterListEvents from "../../events/LaterListEvents";

export class AuthHandler {
    public static login(loginUser: Login) : Promise<any> {
        return new Promise<any> (function (resolve, reject) {
            axios.post(apiUrl + '/users/login' , loginUser, {withCredentials: true}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static logOut() : Promise<any> {
        return new Promise<any> (function (resolve, reject) {
            axios.get(apiUrl + '/users/logout' , {withCredentials: true}).then((response) => {
                CartEvents.callCartModifiedEvents();
                LaterListEvents.callLaterListModifiedEvents();
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static isLogged() : Promise<any> {
        return new Promise<any> (function (resolve, reject) {
            axios.get(apiUrl + '/users/auth' , {withCredentials: true}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static getShippingAddresses() : Promise<any> {
        return new Promise<any> (function (resolve, reject) {
            axios.get(apiUrl + '/users/shippingAddresses' , {withCredentials: true}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }
}
